// This plugin is a placeholder to maintain backward compatibility while the new
// toolbar is not out.
export default (function () {
  return [];
});